module.exports = __webpack_public_path__ + "img/e_3_26_g.b15180ac.png";